"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadingContainer = exports.ConfirmHeading = exports.ErrorCircleStyled = exports.CheckCircleStyled = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const CheckCircle_1 = __importDefault(require("@kyruus/react-ikons/CheckCircle"));
const ErrorCircle_1 = __importDefault(require("@kyruus/react-ikons/ErrorCircle"));
exports.CheckCircleStyled = (0, styled_1.default)(CheckCircle_1.default) `
  color: ${(0, ui_theme_1.fromTheme)('color_icon_green')};
`;
exports.ErrorCircleStyled = (0, styled_1.default)(ErrorCircle_1.default) `
  color: ${(0, ui_theme_1.fromTheme)('color_warning')};
`;
exports.ConfirmHeading = (0, styled_1.default)('h2') `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_3')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  margin: 0 0 ${(0, ui_theme_1.fromTheme)('spacing_large')} 0;
`;
exports.HeadingContainer = (0, styled_1.default)('div') `
  display: flex;
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  border-bottom: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};

  svg {
    min-width: ${(0, ui_theme_1.fromTheme)('font_size_heading_2')};
    min-height: ${(0, ui_theme_1.fromTheme)('font_size_heading_2')};
    margin-right: 10px; // using 10 here to get the different size icons to line up
  }
`;
//# sourceMappingURL=styles.js.map